if not App.angularApp?
    return

# This directive allows for a cleaner invocation of our
# plupload widget (widget_myUploader)
#
# Usage: Attach the directive to your container of choice
# (i.e. an empty div with the class 'upload_container')
# with the following attributes object:
# {
#   add_btn:  the class of the button you wish to use as your
#             'browse' button (opens file selection dialog)
#
#   url:      backend url that will handle file uploads
#
#   filters:  an object containing various filter params (see docs)
#             such as 'title' and 'extensions'
#
#   callback: an optional function (promise) that will be called
#             when plupload fires it's UploadComplete event
#
#   resolve:  an optional callback function that will be called
#             when the above promise is resolved
# }
#
# Example: grower/views/data/maps_upload/files.blade.php


App.angularApp.directive 'mfPluploader', ['$parse', ($parse) ->
    return {
        restrict: 'A'
        link: (scope, elem, attrs) =>
            pluploadOpts = attrs.mfPluploader
            opts = $parse(pluploadOpts)(scope)
            uploader = $(elem).myUploader
                add_btn: $(".#{opts.add_btn}")
                plupload_options:
                    url: opts.url
                    filters: [ opts.filters ]

                    onComplete: (elem, uploader) =>
                        if opts?.callback?
                            if opts.resolve?
                                opts.callback().then (response) =>
                                    opts.resolve()
                            else
                                opts.callback()

            # Give the controller a reference to the pluploader
            scope.uploader = $(elem).myUploader('getUploader')
    }
]
